import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 14 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7 15.5a6.5 6.5 0 0 1-2.634-.534 6.9 6.9 0 0 1-2.138-1.444 6.9 6.9 0 0 1-1.444-2.137A6.5 6.5 0 0 1 .25 8.75q0-.318.216-.534A.73.73 0 0 1 1 8q.318 0 .534.216a.73.73 0 0 1 .216.534q0 2.195 1.528 3.722T7 14q2.194 0 3.722-1.528T12.25 8.75 10.722 5.03Q9.193 3.499 7 3.5h-.112l.637.638q.225.225.216.525a.765.765 0 0 1-.75.76.7.7 0 0 1-.535-.216L4.525 3.275A.72.72 0 0 1 4.3 2.75q0-.3.225-.525L6.456.295a.7.7 0 0 1 .535-.216.765.765 0 0 1 .75.759.69.69 0 0 1-.216.525L6.887 2H7a6.5 6.5 0 0 1 2.634.535 6.9 6.9 0 0 1 2.138 1.443 6.9 6.9 0 0 1 1.444 2.138 6.5 6.5 0 0 1 .534 2.634 6.5 6.5 0 0 1-.534 2.635 6.9 6.9 0 0 1-1.444 2.137 6.9 6.9 0 0 1-2.138 1.444A6.5 6.5 0 0 1 7 15.5" }, null, -1)
  ])))
}
export default { render: render }